module.exports = __webpack_public_path__ + "static/media/login_icon.b60718c4.svg";